import React, { createContext, useContext } from 'react';

export const ConfigTableModalGateContext = createContext<boolean>(false);

export const ConfigTableModalGateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <ConfigTableModalGateContext.Provider value={true}>{children}</ConfigTableModalGateContext.Provider>
);

export const useConfigTableModalGate = (): boolean => useContext(ConfigTableModalGateContext);
